export function isoToRealDate(isoDate: string | Date): string {
  let d: Date = isoDate instanceof Date ? isoDate : new Date(isoDate);

  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
}
